//# sourceMappingURL=route.mjs.map
/// <reference types="./route.d.mts" />
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $uri from "../../gleam_stdlib/gleam/uri.mjs";
import * as $modem from "../../modem/modem.mjs";
import { Ok, toList, Empty as $Empty, CustomType as $CustomType } from "../gleam.mjs";

export class Administration extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Route$Administration = ($0) => new Administration($0);
export const Route$isAdministration = (value) =>
  value instanceof Administration;
export const Route$Administration$0 = (value) => value[0];

export class ContentLibrary extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Route$ContentLibrary = ($0) => new ContentLibrary($0);
export const Route$isContentLibrary = (value) =>
  value instanceof ContentLibrary;
export const Route$ContentLibrary$0 = (value) => value[0];

export class Organization extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Route$Organization = ($0) => new Organization($0);
export const Route$isOrganization = (value) => value instanceof Organization;
export const Route$Organization$0 = (value) => value[0];

export class Project extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Route$Project = ($0) => new Project($0);
export const Route$isProject = (value) => value instanceof Project;
export const Route$Project$0 = (value) => value[0];

export class Proposal extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Route$Proposal = ($0) => new Proposal($0);
export const Route$isProposal = (value) => value instanceof Proposal;
export const Route$Proposal$0 = (value) => value[0];

export class NotFound extends $CustomType {}
export const Route$NotFound = () => new NotFound();
export const Route$isNotFound = (value) => value instanceof NotFound;

export class Maintenance extends $CustomType {}
export const Administration$Maintenance = () => new Maintenance();
export const Administration$isMaintenance = (value) =>
  value instanceof Maintenance;

export class ChoiceTranslations extends $CustomType {
  constructor(page) {
    super();
    this.page = page;
  }
}
export const Administration$ChoiceTranslations = (page) =>
  new ChoiceTranslations(page);
export const Administration$isChoiceTranslations = (value) =>
  value instanceof ChoiceTranslations;
export const Administration$ChoiceTranslations$page = (value) => value.page;
export const Administration$ChoiceTranslations$0 = (value) => value.page;

export class SectionTranslations extends $CustomType {
  constructor(page) {
    super();
    this.page = page;
  }
}
export const Administration$SectionTranslations = (page) =>
  new SectionTranslations(page);
export const Administration$isSectionTranslations = (value) =>
  value instanceof SectionTranslations;
export const Administration$SectionTranslations$page = (value) => value.page;
export const Administration$SectionTranslations$0 = (value) => value.page;

export class ModelAssignments extends $CustomType {}
export const Administration$ModelAssignments = () => new ModelAssignments();
export const Administration$isModelAssignments = (value) =>
  value instanceof ModelAssignments;

export class Jobs extends $CustomType {}
export const Administration$Jobs = () => new Jobs();
export const Administration$isJobs = (value) => value instanceof Jobs;

export class Websites extends $CustomType {}
export const Administration$Websites = () => new Websites();
export const Administration$isWebsites = (value) => value instanceof Websites;

export class DataSources extends $CustomType {
  constructor(page) {
    super();
    this.page = page;
  }
}
export const ContentLibrary$DataSources = (page) => new DataSources(page);
export const ContentLibrary$isDataSources = (value) =>
  value instanceof DataSources;
export const ContentLibrary$DataSources$page = (value) => value.page;
export const ContentLibrary$DataSources$0 = (value) => value.page;

export class IngestionControl extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const ContentLibrary$IngestionControl = ($0) => new IngestionControl($0);
export const ContentLibrary$isIngestionControl = (value) =>
  value instanceof IngestionControl;
export const ContentLibrary$IngestionControl$0 = (value) => value[0];

export class Controls extends $CustomType {}
export const IngestionControl$Controls = () => new Controls();
export const IngestionControl$isControls = (value) => value instanceof Controls;

export class Control extends $CustomType {
  constructor(source_id) {
    super();
    this.source_id = source_id;
  }
}
export const IngestionControl$Control = (source_id) => new Control(source_id);
export const IngestionControl$isControl = (value) => value instanceof Control;
export const IngestionControl$Control$source_id = (value) => value.source_id;
export const IngestionControl$Control$0 = (value) => value.source_id;

export class Authentication extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Organization$Authentication = ($0) => new Authentication($0);
export const Organization$isAuthentication = (value) =>
  value instanceof Authentication;
export const Organization$Authentication$0 = (value) => value[0];

export class Setup extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Organization$Setup = ($0) => new Setup($0);
export const Organization$isSetup = (value) => value instanceof Setup;
export const Organization$Setup$0 = (value) => value[0];

export class AiSearch extends $CustomType {}
export const Organization$AiSearch = () => new AiSearch();
export const Organization$isAiSearch = (value) => value instanceof AiSearch;

export class Automations extends $CustomType {}
export const Organization$Automations = () => new Automations();
export const Organization$isAutomations = (value) =>
  value instanceof Automations;

export class FeatureFlags extends $CustomType {}
export const Organization$FeatureFlags = () => new FeatureFlags();
export const Organization$isFeatureFlags = (value) =>
  value instanceof FeatureFlags;

export class Status extends $CustomType {}
export const Organization$Status = () => new Status();
export const Organization$isStatus = (value) => value instanceof Status;

export class Weaviate extends $CustomType {}
export const Organization$Weaviate = () => new Weaviate();
export const Organization$isWeaviate = (value) => value instanceof Weaviate;

export class ListUsers extends $CustomType {}
export const Authentication$ListUsers = () => new ListUsers();
export const Authentication$isListUsers = (value) => value instanceof ListUsers;

export class InviteUsers extends $CustomType {}
export const Authentication$InviteUsers = () => new InviteUsers();
export const Authentication$isInviteUsers = (value) =>
  value instanceof InviteUsers;

export class ListProjectFile extends $CustomType {}
export const Project$ListProjectFile = () => new ListProjectFile();
export const Project$isListProjectFile = (value) =>
  value instanceof ListProjectFile;

export class VersioningList extends $CustomType {}
export const Proposal$VersioningList = () => new VersioningList();
export const Proposal$isVersioningList = (value) =>
  value instanceof VersioningList;

export class Versioning extends $CustomType {
  constructor(proposal_id) {
    super();
    this.proposal_id = proposal_id;
  }
}
export const Proposal$Versioning = (proposal_id) => new Versioning(proposal_id);
export const Proposal$isVersioning = (value) => value instanceof Versioning;
export const Proposal$Versioning$proposal_id = (value) => value.proposal_id;
export const Proposal$Versioning$0 = (value) => value.proposal_id;

export class ProposalTranslations extends $CustomType {
  constructor(proposal_id) {
    super();
    this.proposal_id = proposal_id;
  }
}
export const Proposal$ProposalTranslations = (proposal_id) =>
  new ProposalTranslations(proposal_id);
export const Proposal$isProposalTranslations = (value) =>
  value instanceof ProposalTranslations;
export const Proposal$ProposalTranslations$proposal_id = (value) =>
  value.proposal_id;
export const Proposal$ProposalTranslations$0 = (value) => value.proposal_id;

export class Init extends $CustomType {}
export const Setup$Init = () => new Init();
export const Setup$isInit = (value) => value instanceof Init;

export class Config extends $CustomType {}
export const Setup$Config = () => new Config();
export const Setup$isConfig = (value) => value instanceof Config;

export class Prompts extends $CustomType {}
export const Setup$Prompts = () => new Prompts();
export const Setup$isPrompts = (value) => value instanceof Prompts;

export function from_uri(uri) {
  let $ = $uri.path_segments(uri.path);
  if ($ instanceof $Empty) {
    return new Administration(new Maintenance());
  } else {
    let $1 = $.tail;
    if ($1 instanceof $Empty) {
      let $2 = $.head;
      if ($2 === "content-library") {
        return new ContentLibrary(new IngestionControl(new Controls()));
      } else {
        return new NotFound();
      }
    } else {
      let $2 = $1.tail;
      if ($2 instanceof $Empty) {
        let $3 = $.head;
        if ($3 === "content-library") {
          let $4 = $1.head;
          if ($4 === "data-sources") {
            return new ContentLibrary(
              new DataSources(
                (() => {
                  let _pipe = $option.unwrap(uri.query, "");
                  let _pipe$1 = $uri.parse_query(_pipe);
                  let _pipe$2 = $result.try$(
                    _pipe$1,
                    (_capture) => { return $list.key_find(_capture, "page"); },
                  );
                  let _pipe$3 = $result.try$(_pipe$2, $int.parse);
                  let _pipe$4 = $result.map(
                    _pipe$3,
                    (_capture) => { return $int.subtract(_capture, 1); },
                  );
                  return $result.unwrap(_pipe$4, 0);
                })(),
              ),
            );
          } else {
            return new NotFound();
          }
        } else if ($3 === "organization") {
          let $4 = $1.head;
          if ($4 === "search") {
            return new Organization(new AiSearch());
          } else if ($4 === "users") {
            return new Organization(new Authentication(new ListUsers()));
          } else if ($4 === "automations") {
            return new Organization(new Automations());
          } else if ($4 === "feature-flags") {
            return new Organization(new FeatureFlags());
          } else if ($4 === "status") {
            return new Organization(new Status());
          } else if ($4 === "weaviate") {
            return new Organization(new Weaviate());
          } else {
            return new NotFound();
          }
        } else if ($3 === "administration") {
          let $4 = $1.head;
          if ($4 === "maintenance") {
            return new Administration(new Maintenance());
          } else if ($4 === "choice-translations") {
            return new Administration(
              new ChoiceTranslations(
                (() => {
                  let _pipe = $option.unwrap(uri.query, "");
                  let _pipe$1 = $uri.parse_query(_pipe);
                  let _pipe$2 = $result.try$(
                    _pipe$1,
                    (_capture) => { return $list.key_find(_capture, "page"); },
                  );
                  let _pipe$3 = $result.try$(_pipe$2, $int.parse);
                  let _pipe$4 = $result.map(
                    _pipe$3,
                    (_capture) => { return $int.subtract(_capture, 1); },
                  );
                  return $result.unwrap(_pipe$4, 0);
                })(),
              ),
            );
          } else if ($4 === "section-translations") {
            return new Administration(
              new SectionTranslations(
                (() => {
                  let _pipe = $option.unwrap(uri.query, "");
                  let _pipe$1 = $uri.parse_query(_pipe);
                  let _pipe$2 = $result.try$(
                    _pipe$1,
                    (_capture) => { return $list.key_find(_capture, "page"); },
                  );
                  let _pipe$3 = $result.try$(_pipe$2, $int.parse);
                  let _pipe$4 = $result.map(
                    _pipe$3,
                    (_capture) => { return $int.subtract(_capture, 1); },
                  );
                  return $result.unwrap(_pipe$4, 0);
                })(),
              ),
            );
          } else if ($4 === "model-assignments") {
            return new Administration(new ModelAssignments());
          } else if ($4 === "jobs") {
            return new Administration(new Jobs());
          } else if ($4 === "websites") {
            return new Administration(new Websites());
          } else {
            return new NotFound();
          }
        } else if ($3 === "project") {
          let $4 = $1.head;
          if ($4 === "file") {
            return new Project(new ListProjectFile());
          } else {
            return new NotFound();
          }
        } else if ($3 === "proposal") {
          let $4 = $1.head;
          if ($4 === "versioning") {
            return new Proposal(new VersioningList());
          } else {
            return new NotFound();
          }
        } else {
          return new NotFound();
        }
      } else {
        let $3 = $2.tail;
        if ($3 instanceof $Empty) {
          let $4 = $.head;
          if ($4 === "content-library") {
            let $5 = $1.head;
            if ($5 === "data-sources") {
              let source_id = $2.head;
              return new ContentLibrary(
                new IngestionControl(new Control(source_id)),
              );
            } else {
              return new NotFound();
            }
          } else if ($4 === "organization") {
            let $5 = $1.head;
            if ($5 === "users") {
              let $6 = $2.head;
              if ($6 === "invite") {
                return new Organization(new Authentication(new InviteUsers()));
              } else {
                return new NotFound();
              }
            } else if ($5 === "ai") {
              let $6 = $2.head;
              if ($6 === "setup") {
                return new Organization(new Setup(new Init()));
              } else if ($6 === "config") {
                return new Organization(new Setup(new Config()));
              } else if ($6 === "prompts") {
                return new Organization(new Setup(new Prompts()));
              } else {
                return new NotFound();
              }
            } else {
              return new NotFound();
            }
          } else if ($4 === "proposal") {
            let $5 = $1.head;
            if ($5 === "versioning") {
              let proposal_id = $2.head;
              return new Proposal(new Versioning(proposal_id));
            } else if ($5 === "translations") {
              let proposal_id = $2.head;
              return new Proposal(new ProposalTranslations(proposal_id));
            } else {
              return new NotFound();
            }
          } else {
            return new NotFound();
          }
        } else {
          return new NotFound();
        }
      }
    }
  }
}

function not_found() {
  return new $uri.Uri(
    new None(),
    new None(),
    new None(),
    new None(),
    "#",
    new None(),
    new None(),
  );
}

export function to_uri(route) {
  let _block;
  if (route instanceof Administration) {
    let $ = route[0];
    if ($ instanceof Maintenance) {
      _block = $uri.parse("/administration/maintenance");
    } else if ($ instanceof ChoiceTranslations) {
      let page = $.page;
      let page$1 = $int.to_string(page + 1);
      _block = $uri.parse("/administration/choice-translations?page=" + page$1);
    } else if ($ instanceof SectionTranslations) {
      let page = $.page;
      let page$1 = $int.to_string(page + 1);
      _block = $uri.parse("/administration/section-translations?page=" + page$1);
    } else if ($ instanceof ModelAssignments) {
      _block = $uri.parse("/administration/model-assignments");
    } else if ($ instanceof Jobs) {
      _block = $uri.parse("/administration/jobs");
    } else {
      _block = $uri.parse("/administration/websites");
    }
  } else if (route instanceof ContentLibrary) {
    let $ = route[0];
    if ($ instanceof DataSources) {
      let page = $.page;
      let page$1 = $int.to_string(page + 1);
      _block = $uri.parse("/content-library/data-sources?page=" + page$1);
    } else {
      let $1 = $[0];
      if ($1 instanceof Controls) {
        _block = $uri.parse("/content-library");
      } else {
        let id = $1.source_id;
        _block = $uri.parse("/content-library/data-sources/" + id);
      }
    }
  } else if (route instanceof Organization) {
    let $ = route[0];
    if ($ instanceof Authentication) {
      let $1 = $[0];
      if ($1 instanceof ListUsers) {
        _block = $uri.parse("/organization/users");
      } else {
        _block = $uri.parse("/organization/users/invite");
      }
    } else if ($ instanceof Setup) {
      let $1 = $[0];
      if ($1 instanceof Init) {
        _block = $uri.parse("/organization/ai/setup");
      } else if ($1 instanceof Config) {
        _block = $uri.parse("/organization/ai/config");
      } else {
        _block = $uri.parse("/organization/ai/prompts");
      }
    } else if ($ instanceof AiSearch) {
      _block = $uri.parse("/organization/search");
    } else if ($ instanceof Automations) {
      _block = $uri.parse("/organization/automations");
    } else if ($ instanceof FeatureFlags) {
      _block = $uri.parse("/organization/feature-flags");
    } else if ($ instanceof Status) {
      _block = $uri.parse("/organization/status");
    } else {
      _block = $uri.parse("/organization/weaviate");
    }
  } else if (route instanceof Project) {
    _block = $uri.parse("/project/file");
  } else if (route instanceof Proposal) {
    let $ = route[0];
    if ($ instanceof VersioningList) {
      _block = $uri.parse("/proposal/versioning");
    } else if ($ instanceof Versioning) {
      let id = $.proposal_id;
      _block = $uri.parse("/proposal/versioning/" + id);
    } else {
      let id = $.proposal_id;
      _block = $uri.parse("/proposal/translations/" + id);
    }
  } else {
    _block = new Ok(not_found());
  }
  let _pipe = _block;
  return $result.lazy_unwrap(_pipe, not_found);
}

export function to_title(route) {
  return $string.append(
    "Admin — ",
    (() => {
      if (route instanceof Administration) {
        let $ = route[0];
        if ($ instanceof Maintenance) {
          return "Maintenance";
        } else if ($ instanceof ChoiceTranslations) {
          return "Choice Translations";
        } else if ($ instanceof SectionTranslations) {
          return "Section Translations";
        } else if ($ instanceof ModelAssignments) {
          return "Model assignments";
        } else if ($ instanceof Jobs) {
          return "Jobs";
        } else {
          return "Websites";
        }
      } else if (route instanceof ContentLibrary) {
        let $ = route[0];
        if ($ instanceof DataSources) {
          return "Data Sources Viewer";
        } else {
          let $1 = $[0];
          if ($1 instanceof Controls) {
            return "Ingestion Control";
          } else {
            return "Ingestion Control";
          }
        }
      } else if (route instanceof Organization) {
        let $ = route[0];
        if ($ instanceof Authentication) {
          let $1 = $[0];
          if ($1 instanceof ListUsers) {
            return "Users";
          } else {
            return "Invite Users";
          }
        } else if ($ instanceof Setup) {
          let $1 = $[0];
          if ($1 instanceof Init) {
            return "Organization — AI Setup";
          } else if ($1 instanceof Config) {
            return "Organization — AI Config";
          } else {
            return "Organization — Prompts";
          }
        } else if ($ instanceof AiSearch) {
          return "Organization — AI Search";
        } else if ($ instanceof Automations) {
          return "Automations";
        } else if ($ instanceof FeatureFlags) {
          return "Feature flags";
        } else if ($ instanceof Status) {
          return "Organization — Status";
        } else {
          return "Weaviate";
        }
      } else if (route instanceof Project) {
        return "Project File";
      } else if (route instanceof Proposal) {
        let $ = route[0];
        if ($ instanceof VersioningList) {
          return "Proposal Versioning";
        } else if ($ instanceof Versioning) {
          return "Proposal Versioning";
        } else {
          return "Proposal Translations";
        }
      } else {
        return "Not Found";
      }
    })(),
  );
}

/**
 * Read the selected organization id from an URL query (`?org_id=...`).
 * Returns `None` when the parameter is absent, so callers can fall back on the
 * org_id carried by the JWT.
 */
export function org_from_uri(uri) {
  let _pipe = $option.unwrap(uri.query, "");
  let _pipe$1 = $uri.parse_query(_pipe);
  let _pipe$2 = $result.try$(
    _pipe$1,
    (_capture) => { return $list.key_find(_capture, "org_id"); },
  );
  return $option.from_result(_pipe$2);
}

/**
 * Inject the selected organization id into an URL query as `org_id`, keeping
 * any existing query parameter (e.g. `page`). A `None` org leaves the URL
 * untouched.
 */
export function with_org(uri, org_id) {
  if (org_id instanceof Some) {
    let org_id$1 = org_id[0];
    let _block;
    let _pipe = $option.unwrap(uri.query, "");
    let _pipe$1 = $uri.parse_query(_pipe);
    let _pipe$2 = $result.unwrap(_pipe$1, toList([]));
    let _pipe$3 = $list.filter(
      _pipe$2,
      (param) => { return param[0] !== "org_id"; },
    );
    _block = $list.append(_pipe$3, toList([["org_id", org_id$1]]));
    let params = _block;
    return new $uri.Uri(
      uri.scheme,
      uri.userinfo,
      uri.host,
      uri.port,
      uri.path,
      new Some($uri.query_to_string(params)),
      uri.fragment,
    );
  } else {
    return uri;
  }
}

/**
 * Push new `Route` to modem, preserving the selected organization in the URL.
 * Prevent to pipe `to_uri` function each time you want to use `modem.push`
 *
 * ```gleam
 * route.NotFound |> route.push(store.organization)
 * ```
 */
export function push(route, org_id) {
  let _block;
  let _pipe = to_uri(route);
  _block = with_org(_pipe, org_id);
  let uri = _block;
  return $modem.push(uri.path, uri.query, uri.fragment);
}

/**
 * Replace `Route` to modem, preserving the selected organization in the URL.
 * Prevent to pipe `to_uri` function each time you want to use `modem.replace`
 *
 * ```gleam
 * route.NotFound |> route.replace(store.organization)
 * ```
 */
export function replace(route, org_id) {
  let _block;
  let _pipe = to_uri(route);
  _block = with_org(_pipe, org_id);
  let uri = _block;
  return $modem.replace(uri.path, uri.query, uri.fragment);
}
